import { useState } from "react";
import { AlertTriangle, Info, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const COUNTRIES = [
  ["NZ", "New Zealand"], ["AU", "Australia"], ["GB", "United Kingdom"], ["US", "United States"],
  ["DE", "Germany"], ["FR", "France"], ["CA", "Canada"], ["AE", "UAE"], ["SG", "Singapore"], ["XX", "Other"],
];

const STYLES = {
  info: "bg-[#eef3ee] text-[#1f402b] border-[#d3e0d6]",
  caution: "bg-[#f7efe1] text-[#6b4a14] border-[#ead9b9]",
  restricted: "bg-[#fbeaea] text-[#7a1d1d] border-[#efcfcf]",
};

export default function RegionalBanner() {
  const { geo, setCountry } = useSite();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("kb_banner_hidden") === "1");
  const notice = geo?.notice;
  if (!notice || hidden) return null;
  const level = notice.level || "info";
  const Icon = level === "info" ? Info : AlertTriangle;

  const hide = () => {
    sessionStorage.setItem("kb_banner_hidden", "1");
    setHidden(true);
  };

  return (
    <div className={`border-b ${STYLES[level] || STYLES.info}`} data-testid="regional-notice-banner" data-level={level}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex items-start sm:items-center gap-3 text-[13px]">
        <Icon size={15} className="shrink-0 mt-0.5 sm:mt-0" />
        <p className="flex-1 leading-snug" data-testid="regional-notice-message">
          <span className="font-mono-k text-[10px] uppercase tracking-widest mr-2 opacity-80">
            {geo.country_code || "Unknown region"}
          </span>
          {notice.message}
        </p>
        <select
          aria-label="Change region"
          value={geo.country_code || ""}
          onChange={(e) => setCountry(e.target.value)}
          className="bg-transparent border border-current/20 text-[12px] px-1 sm:px-2 py-1 rounded-sm max-w-[124px] sm:max-w-none"
          data-testid="region-select"
        >
          {!geo.country_code && <option value="">Choose region</option>}
          {geo.country_code && !COUNTRIES.find(([c]) => c === geo.country_code) && (
            <option value={geo.country_code}>{geo.country_code}</option>
          )}
          {COUNTRIES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
        </select>
        <button onClick={hide} aria-label="Dismiss notice" data-testid="regional-notice-dismiss" className="p-1 opacity-70 hover:opacity-100">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
